export default __webpack_public_path__ + "static/apace Logo_Main Logo-b6619eaca5b8f793486e6b9711151653.svg";